import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
var generateStyle = function generateStyle(componentTheme) {
  var mq = "@media screen and ".concat(componentTheme.phoneBreakPoint);
  return {
    centileRoot: _defineProperty({
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'center',
      overflow: 'hidden',
      '& > div': {
        flex: '0 1 51rem'
      },
      svg: {
        overflow: 'visible'
      }
    }, mq, {
      barLabel: {
        fontSize: componentTheme.phoneBarLabelFontSize
      },
      xAxis: {
        '&g:nth-child(2n+1)': {
          display: 'none'
        }
      }
    })
  };
};
export default generateStyle;